Alpine.data('alpine_team_member_contact', (teamMemberId) => ({
  errors: {},
  submitted: false,
  success: false,
  teamMemberContactModalOpen: false,
  teamMemberId: teamMemberId,

  init() {
    this.$watch('teamMemberContactModalOpen', value => {
      if(!value) {
        this.clearFormInput(this.$el.querySelector('form'));
      }
    });
  },

  clearError(key) {
      delete this.errors[key];
  },

  hasError(key) {
      return this.errors.hasOwnProperty(key)
          && !!this.errors[key];
  },

  clearFormInput(form) {
    form.querySelectorAll('input, textarea')
      .forEach(input => {
        input.value = '';
      });
  },

  async submit(event) {
      event.preventDefault();

      const submitEvent = event;

      this.errors = {};

      if(this.submitted) {
          return false;
      }

      this.submitted = true;

      let data = new FormData(event.target);
      data.append('team_member_id', this.teamMemberId);

      await window.axios.post(event.target.action, data)
          .then(response => {
              this.success = true;

              setTimeout(() => this.success = false, 5000);

              this.clearFormInput(submitEvent.target);
          })
          .catch(error => {
              if(error.response && !error.response.data?.exception) {
                  this.errors = error.response.data.errors || {fail: error.response.data.message};
              } else {
                  this.errors = {fail: 'An unknown error has occurred.'}
              }
          })
          .finally(() => this.submitted = false);
  },
}));
